const withIdMixin = {
  methods: 
  {
    onIdChange(){}
  },

  computed:
  {
    idParam()
    {
      return this.$route.params.id
    }
  },

  watch:
  {
    idParam(newId, oldId)
    {
      if( oldId && newId !== oldId && this.load ){
        
        this.load()

        this.onIdChange()
      }
    }
  }
}

export default withIdMixin